import { Box, Typography } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import EmployeeList from "./employeeList";
import ScoreList from "./scoreList";
import CampaignInfo from "./campaignInfo";

function ViewDetails({ id, campaignList }) {

    console.log('dataList', campaignList);

    return (
        <Box
            sx={{
                width: "100%",
                px: { xs: 2 }, // padding for mobile and desktop
                py: { xs: 1 },        // vertical padding for mobile and desktop
            }}
        >
            {/* <BasicBreadcrumbs first="Mission Info" /> */}
            <CampaignInfo data={campaignList} id={id} />
            <Box>
            </Box>
            {/* <Typography variant="h6" sx={{ mb: 2, fontWeight: "600", textTransform: 'uppercase' }}>
                Employee Listing
            </Typography>
            <EmployeeList id={id} /> */}
            <ScoreList id={id} />
        </Box>
    );
}

export default ViewDetails;